module.exports = __webpack_public_path__ + "static/media/windshield-protection_color.7e4bd430.png";